import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";

import BBIconAdd from "../../../assets/bbCustomIcons/BBIconAdd";
import BBIconRocketSharpAdd from "../../../assets/bbCustomIcons/BBIconRocketSharpAdd";
import BRPortfolioAddNewEntityForm from "./BRPortfolioAddNewEntityForm";
import {useSelector} from "react-redux";
import {CircularProgress} from "@mui/material";
import BBIconAddFolderGroup from "../../../assets/bbCustomIcons/BBIconAddFolderGroup";
import BRPortfolioAddNewSubportfolioForm from "./BRPortfolioAddNewSubportfolioForm";
import BBIconAddToGroupCollection from "../../../assets/bbCustomIcons/BBIconAddToGroupCollection";
import BRPortfolioAddEntityToSubportfolioForm from "./BRPortfolioAddEntityToSubportfolioForm";
import BBIconRemoveFromGroupCollection from "../../../assets/bbCustomIcons/BBIconRemoveFromGroupCollection";
import BRPortfolioRemoveEntityFromSubportfolioForm from "./BRPortfolioRemoveEntityFromSubportfolioForm";
import BRPortfolioDeleteSubportfolioForm from "./BRPortfolioDeleteSubportfolioForm";
import BBIconTrash from "../../../assets/bbCustomIcons/BBIconTrash";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const FormDialog = (props) => {

    const {
        iconOnly = false,
        iconSize = null,
        targetCustomerId,
        targetEntity,
        targetSubportfolio
    } = props;
    // console.log("Dialog for adding customer to portfolio. ", targetCustomerId)
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, loadingPortfolios, loadingAddBRPortfolioEntity, loadingAddBRPortfolioEntityError} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <div>
            <Tooltip title={"Delete this portfolio group."}>
                <Button
                    variant="outlined"
                    color="default"
                    onClick={handleClickOpen}
                    // className={"text-electric-blue"}
                >
                    {iconOnly
                        ? <BBIconTrash style={{fontSize: "70px"}}/>
                        : <><BBIconTrash className={""}/></>
                    }

                </Button>
            </Tooltip>

            <Dialog
                fullWidth={false}
                maxWidth={"xl"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Delete a Portfolio Group
                </DialogTitle>
                <DialogContent>
                    {/*<DialogContentText>*/}
                    {/*    You can remove companies from your portfolio groups. You can always add them back later.*/}
                    {/*</DialogContentText>*/}
                         <div className={"border-2 p-3 row"}>
                    {   loadingAddBRPortfolioEntity[customerIdToUse]
                        ? <div className={"col-12 text-center"}>
                            <CircularProgress size={72} className={"align-items-center"}/>
                    </div>
                        :<BRPortfolioDeleteSubportfolioForm targetEntity={targetEntity} targetSubportfolio={targetSubportfolio} closerCallback={handleClose}/>
                    }
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog;
